export const soldProducts = {
	label: "Total de productos vendidos",
	sheetFileName: "total-productos-vendidos",
	since: "Desde",
	until: "Hasta",
	downloadAllSales: "Descargar todas las ventas",
	loading: "Generando hoja de cálculo",
	filter: {
		label: "Filtrar por tipo de transacción",
		placeholder: "Todas",
		all: "Todos",
		balcony: "Mostrador",
		cashless: "Cashless",
		dashboard: "Panel",
		delivery: "Delivery",
		ficha: "Ficha",
		grabngo: "Grab n Go",
		onlineBill: "Comanda en línea",
		zigQrCode: "QR Code Zig",
		onlineFicha: "Ficha Digital",
		table: "Mesa",
		hce: "Tarjeta Digital",
	},
	columns: {
		fiscalCode: "SKU",
		name: "Nombre",
		mountable: "Compuesto",
		category: "Categoría",
		unitaryCount: "Cantidad Unit.",
		count: "Cantidad",
		variable: "Variable",
		devolution: "Devolución",
		variableTooltip:
			"El valor unitario de productos con valor variable es el promedio de los valores vendidos",
		fracionalCount: {
			label: "Cantidad Frac.",
			grams: "gramos",
			kg: "Kilos",
			lt: "Litros",
		},
		unitaryValue: "Valor unitario",
		subtotal: "Subtotal",
		discount: "Descuentos",
		totalValue: "Valor total",
		grossTotalValue: "Total bruto",
		tax_percentage: "Impuesto %",
		tax_money: "Impuesto {{currencySymbol}}",
		net_sales: "Total neto",
		operationType: "Operación",
	},
	total: "TOTAL",
	totalItem: "Total",
	mountableModal: {
		name: "Nombre",
		section: "Sección Compuesta",
		count: "Cantidad",
	},
	mountables: {
		label: "Compuestos",
		fiscalCode: "SKU",
		product: "Producto",
		category: "Categoría Producto",
		section: "Etapa Compuesta",
		name: "Item Compuesto",
		count: "Cantidad",
	},
	zigCard: "Zig Card",
	zigTable: "Zig Mesa",
	selectDate: "Seleccione la fecha",
	selectTime: "Seleccione la hora",
	selectTimeTooltip: "Seleccione la fecha antes de seleccionar la hora",
};
